<template>
    <div class="logo">
        <v-progress-circular
            v-if="getBrandLoadingStatus"
            :size="40"
            color="rgba(255, 255, 255)"
            indeterminate
        ></v-progress-circular>
        <router-link to="/dashboard" class="dashboard no-underline" v-if="!getBrandLoadingStatus">
            <img :src="getNavigationImageUri ? getNavigationImageUri : defaultNavigationUri" alt="" class="responsive" />
            <!-- <img :src='defaultNavigationUri' alt="" class="responsive show-lg logo" /> -->
            <span v-if="getShowPoweredBy" class="powered-by"> Powered by Spillard Live</span>
            <!-- <img src="../../../assets/images/logo-small.svg" alt="" class="responsive show-md" /> -->
        </router-link>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import logo from '../../../assets/images/logo.svg'

export default {
    name: 'Logo',
    data () {
        return {
            navigationUri: null,
            faviconUri: null,
            defaultNavigationUri: logo,
            isLoading: true
        }
    },
    computed: {
        ...mapGetters('authModule', [
            'getActiveOrganization'
        ]),
        ...mapGetters('brandModule', [
            'getNavigationImageUri',
            'getFaviconImageUri',
            'getShowPoweredBy',
            'getBrandLoadingStatus'
        ])
    },
    mounted () {
        this.handleFavicon()
    },
    methods: {
        handleFavicon () {
            const favicon = document.getElementById('favicon')
            if (this.getFaviconImageUri) {
                favicon.href = this.getFaviconImageUri
            } else {
                favicon.href = '/favicon.ico'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    text-decoration: none;
    ::v-deep .dashboard {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;
        text-decoration: none;
        .powered-by {
            color: $font;
            text-align: end;
        }
    }

    @include breakpoint(md) {
        margin-left: 20px;
        margin-right: 20px;
        width: 200px;
    }

    @media (min-width: 1024px) {
        margin-right: 70px;
    }

    @media (min-width: 1440px) {
        margin-right: 70px;
        margin-left: 20px;
        width: 220px;
    }
    img {
        display: flex;
        margin: 0;
        max-height: 70%;
        width: auto;
        overflow: hidden;
        &.show-md {
            display: none;

            @include breakpoint(md) {
                display: block;
            }
        }

        &.show-lg {
            display: none;

            @include breakpoint(lg) {
                display: block;
            }
        }

    }
}
</style>
